import _ from 'lodash';
import { get } from 'lodash';
import { PERMISSION_ALL_KEYS } from './permission-settings-quick-presets';
import type { EmployeePermissionClassRow } from './permission-settings.types';

/**
 * 权限模板行转为表单勾选态（`payment` 5→1；`extensions` API 翻转）。
 */
export function normalizeRowForForm(item: EmployeePermissionClassRow): EmployeePermissionClassRow {
    const deep = _.cloneDeep(item);
    if (deep.payment === 5) {
        deep.payment = 1;
    }
    const ext = deep.extensions as number | undefined;
    deep.extensions = ext ? 0 : 1;
    return deep;
}

/**
 * 表单勾选态转为 API 权限快照字段（用于 `employee_class` PATCH 或 `permission_override` JSON）。
 */
export function formPermissionRowToApiSnapshot(form: EmployeePermissionClassRow): Record<string, number> {
    const out: Record<string, number> = {};
    for (const key of PERMISSION_ALL_KEYS) {
        const raw = get(form, key, 0);
        if (key === 'payment') {
            out.payment = Number(raw) === 1 ? 5 : 0;
            continue;
        }
        if (key === 'extensions') {
            out.extensions = Number(raw) === 1 ? 0 : 1;
            continue;
        }
        const n = Number(raw);
        out[key] = Number.isFinite(n) && n !== 0 ? 1 : 0;
    }
    return out;
}

/**
 * 比较用：将 API 语义权限位归一为 0/1（`payment` 非 0 视为开；`extensions` 0 为有权限）。
 */
export function normalizePermissionBitForCompare(key: string, value: unknown): 0 | 1 {
    if (key === 'payment') {
        const n = Number(value);
        return Number.isFinite(n) && n !== 0 ? 1 : 0;
    }
    if (key === 'extensions') {
        return Number(value) === 0 ? 1 : 0;
    }
    const n = Number(value);
    return Number.isFinite(n) && n !== 0 ? 1 : 0;
}
